import _createClass from "@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import { API_HOST, CLIENT_ID, BPM_HOST, WFP_EDITOR, WEBSOCKET_URL, IM_ENABLE, CUSTOMIZE_ICON_NAME, HZERO_PLATFORM, HZERO_IAM, HZERO_DTT, HZERO_MSG, HZERO_PTL, HZERO_WFL, HZERO_DTW, HZERO_HDTW, HZERO_SDR, HZERO_HSGP, HZERO_HITF, HZERO_HFLE, HZERO_OAUTH, HZERO_ASGARD, HZERO_IMP, HZERO_RPT, HZERO_HCNF, HZERO_HWFP, HZERO_FILE, HZERO_NLP, HZERO_HPAY, HZERO_HEXL, HZERO_MNT, HZERO_INVOICE, HZERO_IM, HZERO_OCR, HZERO_CHG, HZERO_ADM, HZERO_DPM, HZERO_HSRH, HZERO_HRES, HZERO_HLCD, AUTH_HOST, LOGIN_URL, LOGOUT_URL, AUTH_SELF_URL, VERSION_IS_OP, BKT_PUBLIC, BKT_PLATFORM, BKT_MSG, BKT_SDR, BKT_RPT, BKT_INVOICE, BKT_OCR, BKT_ADM, BKT_HWFP, BKT_HITF } from 'hzero-front/lib/utils/config';
export var ConfigProps = /*#__PURE__*/_createClass(function ConfigProps() {
  _classCallCheck(this, ConfigProps);

  this.HFINS_MAP_API = '/hfsm';
  this.TODO_API = '/htodo';
  this.HEC_BPM_USERNAME = 'Hfins';
  this.HEC_BPM_PSD = 'Z8W4e0k7';
  this.HEC_BPM_SYSTEM_CODE = 'Hfins';
  this.HEC_BPM_BASE_URL = 'https://bpm.vinda.com';
  this.HSSP_API = '/hssp';
  this.HITF_API = '/hitf';
  this.HOA_API = '/hoa';
  this.HDATA_API = '/hdata';
  this.HBGT_API = '/hbgt';
  this.HADT_API = '/hadt';
  this.OPS = '/ops';
  this.BASE_PATH = process.env.BASE_PATH || '/';
  this.API_HOST = API_HOST;
  this.OLD_HOME_PAGE_URL = process.env.OLD_HOME_PAGE_URL || '/';
  this.OLD_BASE_URL = process.env.OLD_BASE_URL || '/';
  this.CLIENT_ID = CLIENT_ID;
  this.BPM_HOST = BPM_HOST;
  this.WFP_EDITOR = WFP_EDITOR;
  this.WEBSOCKET_URL = WEBSOCKET_URL;
  this.IM_ENABLE = IM_ENABLE;
  this.CUSTOMIZE_ICON_NAME = CUSTOMIZE_ICON_NAME;
  this.HZERO_PLATFORM = HZERO_PLATFORM;
  this.HZERO_IAM = HZERO_IAM;
  this.HZERO_DTT = HZERO_DTT;
  this.HZERO_MSG = HZERO_MSG;
  this.HZERO_PTL = HZERO_PTL;
  this.HZERO_WFL = HZERO_WFL;
  this.HZERO_DTW = HZERO_DTW;
  this.HZERO_HDTW = HZERO_HDTW;
  this.HZERO_SDR = HZERO_SDR;
  this.HZERO_HSGP = HZERO_HSGP;
  this.HZERO_HITF = HZERO_HITF;
  this.HZERO_HFLE = HZERO_HFLE;
  this.HZERO_OAUTH = HZERO_OAUTH;
  this.HZERO_ASGARD = HZERO_ASGARD;
  this.HZERO_IMP = HZERO_IMP;
  this.HZERO_RPT = HZERO_RPT;
  this.HZERO_HCNF = HZERO_HCNF;
  this.HZERO_HWFP = HZERO_HWFP;
  this.HZERO_FILE = HZERO_FILE;
  this.HZERO_NLP = HZERO_NLP;
  this.HZERO_HPAY = HZERO_HPAY;
  this.HZERO_HEXL = HZERO_HEXL;
  this.HZERO_MNT = HZERO_MNT;
  this.HZERO_INVOICE = HZERO_INVOICE;
  this.HZERO_IM = HZERO_IM;
  this.HZERO_OCR = HZERO_OCR;
  this.HZERO_CHG = HZERO_CHG;
  this.HZERO_ADM = HZERO_ADM;
  this.HZERO_DPM = HZERO_DPM;
  this.HZERO_HSRH = HZERO_HSRH;
  this.HZERO_HRES = HZERO_HRES;
  this.HZERO_HLCD = HZERO_HLCD;
  this.AUTH_HOST = AUTH_HOST;
  this.LOGIN_URL = LOGIN_URL;
  this.LOGOUT_URL = LOGOUT_URL;
  this.AUTH_SELF_URL = AUTH_SELF_URL;
  this.VERSION_IS_OP = VERSION_IS_OP;
  this.BKT_PUBLIC = BKT_PUBLIC;
  this.BKT_PLATFORM = BKT_PLATFORM;
  this.BKT_MSG = BKT_MSG;
  this.BKT_SDR = BKT_SDR;
  this.BKT_RPT = BKT_RPT;
  this.BKT_INVOICE = BKT_INVOICE;
  this.BKT_OCR = BKT_OCR;
  this.BKT_ADM = BKT_ADM;
  this.BKT_HWFP = BKT_HWFP;
  this.BKT_HITF = BKT_HITF;
});
var HZERO_CONFIG_STORE = '_HZERO_CONFIG_STORE';
export var getConfigStore = function getConfigStore() {
  if (!window[HZERO_CONFIG_STORE]) {
    window[HZERO_CONFIG_STORE] = new ConfigProps();
  }

  return window[HZERO_CONFIG_STORE];
};
export var getConfig = function getConfig(key) {
  return getConfigStore()[key];
};
var commonConfigStore = getConfigStore();
export default commonConfigStore;